import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loader from "../../Components/Common/Loader";
import { Form, Input, DatePicker, Select } from "antd";
import { fetchNationalityList } from "../../redux/getDropDownReducer/getNationalityList";
import { useDispatch, useSelector } from "react-redux";

const { Option } = Select;

const ManualRegistration = () => {
  const [isLoading, setisLoading] = useState(false);

  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [PassportNo, setPassportNo] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [Address, setAddress] = useState("");
  const [Nationality, setNationality] = useState("");
  const [DOB, setDOB] = useState("");
const [ProfilePicture, setProfilePicture] = useState(null);
const [profilePreview, setProfilePreview] = useState(null);

  const { data: NationalityList, status } = useSelector(
  (state) => state.NationalityList
);


const getDefaultAvatarBlob = async () => {
  const response = await fetch("/default-avatar.png"); // public folder
  return await response.blob();
};

const generateRandomPassport = () => {
  return "P" + Math.floor(10000000 + Math.random() * 90000000);
};

const onSelectProfilePicture = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  setProfilePicture(file);
  setProfilePreview(URL.createObjectURL(file));
};

  const history = useNavigate();
const dispatch = useDispatch();

useEffect(() => {
  dispatch(fetchNationalityList({ value: "" }));
}, [dispatch]);
  //----------------------------submit -------------------------//
 const submit = async () => {
  setisLoading(true);
  try {
    const formData = new FormData();

    formData.append("FirstName", FirstName);
    formData.append("LastName", LastName);

    // Passport logic
    const finalPassport =
      PassportNo && PassportNo.trim() !== ""
        ? PassportNo
        : generateRandomPassport();

    formData.append("PassportNo", finalPassport);

    formData.append("PhoneNumber", PhoneNumber);
    formData.append("Email", Email);
    formData.append("Password", Password);
    formData.append("Address", Address);
    formData.append("Nationality", Nationality);
    formData.append("DOB", DOB);

    // Profile picture logic
    if (ProfilePicture) {
      formData.append("ProfilePicture", ProfilePicture);
    } 

    await axios.post(
      `${window.env.API_URL}/admincreate`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    swal({
      title: "Success!",
      text: "User registered successfully",
      icon: "success",
      button: "OK",
    });

    history("/users");
  } catch (error) {
    swal({
      title: "Error!",
      text: error?.response?.data?.message || "Something went wrong",
      icon: "error",
      button: "OK",
    });
  }
  setisLoading(false);
};


  
  return (
    <div className="page">
      <div className="rightsidedata">
        <div style={{ marginTop: "30px" }}>
          <div className="Headers">Manual Registration</div>

          {isLoading ? (
            <Loader />
          ) : (
            <div className="form">
             <Form onFinish={submit}>

  <div className="row mainrow">
    <div className="col-sm">
      <Form.Item
        name="FirstName"
        label="First Name"
        rules={[{ required: true, message: "First Name is required" }]}
      >
        <Input
          placeholder="First Name"
          value={FirstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
      </Form.Item>
    </div>
  </div>

  <div className="row mainrow">
    <div className="col-sm">
      <Form.Item
        name="LastName"
        label="Last Name"
        rules={[{ required: true, message: "Last Name is required" }]}
      >
        <Input
          placeholder="Last Name"
          value={LastName}
          onChange={(e) => setLastName(e.target.value)}
        />
      </Form.Item>
    </div>
  </div>

  <div className="row mainrow">
    <div className="col-sm">
      <Form.Item
        name="PassportNo"
        label="Passport Number"
        // rules={[{ required: true, message: "Passport Number is required" }]}
      >
        <Input
          placeholder="Passport Number"
          value={PassportNo}
          onChange={(e) => setPassportNo(e.target.value)}
        />
      </Form.Item>
    </div>
  </div>

  <div className="row mainrow">
    <div className="col-sm">
      <Form.Item
        name="PhoneNumber"
        label="Phone Number"
        rules={[{ required: true, message: "Phone Number is required" }]}
      >
        <Input
          placeholder="Phone Number"
          value={PhoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
      </Form.Item>
    </div>
  </div>

  <div className="row mainrow">
    <div className="col-sm">
      <Form.Item
        name="Email"
        label="Email"
        rules={[
          { required: true, message: "Email is required" },
          { type: "email", message: "Enter valid email" },
        ]}
      >
        <Input
          placeholder="Email"
          value={Email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Form.Item>
    </div>
  </div>

  <div className="row mainrow">
    <div className="col-sm">
      <Form.Item
        name="Password"
        label="Password"
        rules={[{ required: true, message: "Password is required" }]}
      >
        <Input.Password
          placeholder="Password"
          value={Password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Form.Item>
    </div>
  </div>

  <div className="row mainrow">
    <div className="col-sm">
      <Form.Item
        name="Address"
        label="Address"
        rules={[{ required: true, message: "Address is required" }]}
      >
        <Input.TextArea
          rows={3}
          placeholder="Address"
          value={Address}
          onChange={(e) => setAddress(e.target.value)}
        />
      </Form.Item>
    </div>
  </div>

  <div className="row mainrow">
    <div className="col-sm">
    <Form.Item
  name="Nationality"
  label="Nationality"
  rules={[
    { required: true, message: "Nationality is required" },
  ]}
>
  <Select
    showSearch
    placeholder="Select Nationality"
    filterOption={false}   // server-side search
    loading={status === "loading"}
    onSearch={(value) =>
      dispatch(fetchNationalityList({ value }))
    }
    onChange={(value) => setNationality(value)}
  >
    {NationalityList?.map((item) => (
      <Select.Option key={item._id} value={item._id}>
        {item.NameEn} ({item.NameAr})
      </Select.Option>
    ))}
  </Select>
</Form.Item>

    </div>
  </div>

  <div className="row mainrow">
    <div className="col-sm">
      <Form.Item
        name="DOB"
        label="Date of Birth"
        rules={[{ required: true, message: "Date of Birth is required" }]}
      >
        <DatePicker
          style={{ width: "100%" }}
          onChange={(date, dateString) => setDOB(dateString)}
        />
      </Form.Item>
    </div>
  </div>
  <div className="row">
  <div className="col-sm">
    <label className="Multipleownerlabel">Profile Picture</label>
    <input
      type="file"
      accept="image/*"
      className="formInput"
      onChange={onSelectProfilePicture}
    />

    {profilePreview && (
      <img
        src={profilePreview}
        alt="preview"
        className="PreviewImage"
      />
    )}
  </div>
</div>


  <div className="ButtonSection" style={{ justifyContent: "end" }}>
    <button
      type="submit"
      className="SubmitButton"
      disabled={isLoading}
    >
      Register User
    </button>
  </div>

</Form>

            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManualRegistration;
